export const COLORS = {
  bg: "var(--yuo-bg)",
  surface: "var(--yuo-surface-5)",
  surfaceHover: "var(--yuo-surface-9)",
  border: "var(--yuo-border)",
  mirror: "var(--role-blue-accent)",
  diary: "var(--role-purple-accent)",
  symbiosis: "var(--role-green-accent)",
  library: "var(--role-yellow-accent)",
  content: "var(--role-coral-accent)",
  error: "var(--role-coral-accent)",
  textPrimary: "var(--yuo-ink-hex)",
  textSecondary: "var(--yuo-muted-60)",
  textMuted: "var(--yuo-muted-36)",
};

export const FONTS = {
  heading: "'JetBrains Mono', 'Courier New', ui-monospace, monospace",
  body: "'JetBrains Mono', 'Courier New', ui-monospace, monospace",
};

export const BRAND_ICONS = {
  mirror:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_2531970a-47ed-4129-806c-d3ff3e430ab0/artifacts/yh1wqlbm_IMG_4256.JPG",
  diary:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_2531970a-47ed-4129-806c-d3ff3e430ab0/artifacts/yamlbntz_%20%D0%B4%D0%B2%D0%BE%D0%B8%CC%86%D0%BD%D0%BE%D0%B5%20Upscale_.webp",
  symbiosis:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_2531970a-47ed-4129-806c-d3ff3e430ab0/artifacts/m0efjg1v_IMG_4294.JPG",
  error:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_2531970a-47ed-4129-806c-d3ff3e430ab0/artifacts/jn54wkxc_IMG_4254.JPG",
};

export const SUGGESTIONS = [
  "What should I read tonight to grow my mind?",
  "Help me untangle a decision I've been avoiding.",
  "Give me a small ritual to calm my day.",
  "Explain something beautiful about the universe.",
];
